import 'arrayq';
import { createSelector } from 'reselect';
import { isParticipant } from '../../types';
import { usergroupResource } from '../../usergroup/resource';
import selector from './selectors';

function wildcardMatcherUserGroup(searchTerm: string) {
    if (searchTerm) {
        let term = searchTerm;
        term = term.replace(/[\\]/g, '\\\\');
        term = term.replace(/[\.\?\{\}\[\]\^\$]/g, (x) => `\\${x}`);
        term = term.replace(/\*/g, (x) => `.*`);
        term = term.replace(/\s+/g, ' ');
        term = term.split(' ').qSelect((x) => `(?=.*${x})`).join('');
        const rx = new RegExp(term, 'i');
        return (text: string) => rx.test(text);
    } else {
        return (text: string) => true;
    }
}

const searchTermUsergroupMatcherSelector = createSelector(
    selector.searchTermUsergroupSelector,
    wildcardMatcherUserGroup,
);

export default {   
    UsergroupSelector: createSelector(
        usergroupResource.selectors.items,
        searchTermUsergroupMatcherSelector,
        (items, wildcardMatcherUserGroup) => {
            return items.qWhere((x) =>  (!isParticipant(x) && wildcardMatcherUserGroup(x.name)));
        },
    ), 
    AllUsergroupSelector: createSelector(
        usergroupResource.selectors.items,
        (items) => {
            return items.qWhere((x) => (!isParticipant(x)));
        },
    ),       
};



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/note/noteParticipantSelectPopup/reselectorsusergroup.tsx